import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M207 381.5l-194.3-194.3c-9.4-9.4-9.4-24.6 0-33.9l22.7-22.7c9.4-9.4 24.5-9.4 33.9 0l154.7 154 154.7-154c9.4-9.3 24.5-9.3 33.9 0l22.7 22.7c9.4 9.4 9.4 24.6 0 33.9l-194.3 194.3c-9.4 9.4-24.6 9.4-33.9 0z'
      }
    ]
  }
})
